import { usePage } from "PFApp/use_page";
import { ApiRoute } from "PFCore/utilities/routes";
import { useEffect } from "react";

export const useEditAllowedDomainsPage = (initPage, { id }) => {
  const { page, setPage, mergePage, resetPage } = usePage(
    id ? `allowed_domains/${id}/edit` : `allowed_domains/new`,
    initPage
  );

  const fetchAllowedDomain = ({ id }) => {
    if (id) {
      return $.ajax({
        url: ApiRoute(`/api/admin/allowed_domains/${id}`),
        api_version: 1
      })
        .then((response) =>
          mergePage({
            allowedDomain: response
          })
        )
        .catch(() =>
          mergePage({
            loaded: true,
            errors: ["there was an error"]
          })
        );
    } else {
      mergePage({
        allowedDomain: {
          domain: null,
          id: null,
          obligatory_signin: null
        }
      });
    }
  };

  const fetchAllowedDomainsOptions = () =>
    $.ajax({
      url: ApiRoute(`/api/admin/allowed_domains`),
      api_version: 1
    })
      .then((response) =>
        mergePage({
          options: response.meta.enabled_signin_features
        })
      )
      .catch(() =>
        mergePage({
          loaded: true,
          errors: ["there was an error"]
        })
      );

  const intialFetch = () => {
    $.when(fetchAllowedDomain({ id }), fetchAllowedDomainsOptions()).always(() => {
      mergePage({
        loaded: true
      });
    });
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
  }, []);

  useEffect(() => {
    intialFetch();
  }, []);

  return page;
};
